export default __webpack_public_path__ + "static/media/dashboardIcon2.1c5b856b.svg";